export { default } from './Drawer';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Drawer/index.js
// module id = 757
// module chunks = 121